/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */

import { Container, Button } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { checkValidData, encoder, setSessionStorage } from "utils";
import { Link, useNavigate } from "react-router-dom";
import routesMap from "routeControl/userRouteMap";
import {
  AudioElement,
  CommonButton,
  ImageElement,
  // Loader,
  RippleEffect,
  textFormatter,
  VideoElement,
} from "components";

import { Pagination, Navigation, EffectCoverflow } from "swiper/modules";
import { ext } from "helpers";
// import { checkValidData } from "components/Formatter";
// import { useTranslation } from "react-i18next";
// import { ext } from "helpers";

function CommentSection03({
  role,
  name,
  userId,
  memorialData,
  setCommentModal,
  commentList,
  id,
}) {
  const navigate = useNavigate();
  const onLogin = async () => {
    let path = `/${"theme03"}/${encoder(id)}?${encoder("theme03")}`;
    setSessionStorage("path", path);
    setSessionStorage("theme", "theme03");
    navigate(routesMap.LOGIN.path);
  };
  // const { t } = useTranslation();
  return (
    <>
      <section className="testimonySec light-bg py-80" id="story">
        <Container>
          <div className="commonHead text-center">
            <div className="commonHead_sub">Heartfelt Reflections</div>
            <h2 className="commonHead_title">
              Memories of{" "}
              {checkValidData(textFormatter(memorialData?.firstName))}
              <br className="d-none d-lg-block" />{" "}
              {name?.substr(name?.indexOf(" ") + 1)}
            </h2>

            {/* {role === "user" && ( */}
            <div className="d-flex justify-content-center btnFlex">
              {userId === memorialData?.userId && (
                <RippleEffect>
                  <Link
                    to={`${routesMap.PENDINGCOMMENTS.path}/${encoder(id)}`}
                    className="mt-2 mt-md-4 btn-outline-danger btn"
                  >
                    Pending Comments
                  </Link>
                </RippleEffect>
              )}
              {role === "user" ? (
                <RippleEffect>
                  <CommonButton
                    variant="danger"
                    extraClassName="mt-md-4 mt-2"
                    onClick={() => setCommentModal(true)}
                  >
                    Share A Story
                  </CommonButton>
                </RippleEffect>
              ) : (
                <RippleEffect>
                  <CommonButton
                    variant="danger"
                    extraClassName="mt-md-4 mt-2"
                    onClick={() => onLogin()}
                  >
                    Share A Story
                  </CommonButton>
                </RippleEffect>
              )}
            </div>
          </div>
          {commentList?.length > 0 && (
            <div className="slider testimonySec_inner mx-auto position-relative">
              <Swiper
                // spaceBetween={0}
                slidesPerView={1.1}
                navigation={{
                  nextEl: ".next",
                  prevEl: ".prev",
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    effect: false,
                  },
                  768: {
                    slidesPerView: 1.1,
                  },
                }}
                centeredSlides="true"
                // loop
                effect="coverflow"
                coverflowEffect={{
                  rotate: 0,
                  stretch: 0,
                  depth: 200,
                  modifier: 1,
                  slideShadows: true,
                }}
                modules={[Pagination, Navigation, EffectCoverflow]}
              >
                {commentList.map((comment) => {
                  if (comment?.status === "accept")
                    return (
                      <>
                        <SwiperSlide className="testimonySec_inner mx-auto position-relative">
                          <div className="testimonySec_card position-relative">
                            <div className=" d-sm-flex">
                              <div
                                className={`testimonySec_card_img overflow-hidden flex-shrink-0 flex-column
                                ${
                                  ext?.[
                                    comment?.filePathUrl?.split(".").pop()
                                  ] === "file"
                                    ? "slider_imgbox-pdf testimonySec_card_img-pdf "
                                    : ""
                                }`}
                              >
                                {ext?.[
                                  comment?.filePathUrl?.split(".").pop()
                                ] === "file" && (
                                  <>
                                    <ImageElement
                                      className="smallPic"
                                      source="/theme03/pdf-lg.svg"
                                      alt="pdf"
                                    />
                                    <a
                                      href={comment?.filePathUrl || "#"}
                                      target="blank"
                                      className="viewBtn"
                                    >
                                      View PDF{" "}
                                    </a>
                                  </>
                                )}
                                {ext?.[
                                  comment?.filePathUrl?.split(".").pop()
                                ] === "image" && (
                                  <>
                                    {
                                      comment?.filePathUrl && (
                                        <ImageElement
                                          className="img-fluid h-100 object-fit-cover w-100"
                                          previewSource={comment?.filePathUrl}
                                          alt="commentImage"
                                        />
                                      )
                                      // : (
                                      //   <ImageElement
                                      //     className="img-fluid h-100 object-fit-cover w-100"
                                      //     source="default-comment-img.png"
                                      //     alt="commentImage"
                                      //   />
                                      // )
                                    }
                                  </>
                                )}
                                {ext?.[
                                  comment?.filePathUrl?.split(".").pop()
                                ] === "audio" && (
                                  <AudioElement
                                    classname="d-block m-auto"
                                    previewSource={comment?.filePathUrl}
                                    alt="timeline-img"
                                  />
                                )}
                                {ext?.[
                                  comment?.filePathUrl?.split(".").pop()
                                ] === "video" && (
                                  <>
                                    {/* <Link to="#" className="landmakrPlay">
                                      <em className="icon-video" />
                                    </Link> */}
                                    <VideoElement
                                      previewSource={comment?.filePathUrl}
                                      extraClassName="w-100 h-100 object-fit-cover"
                                      alt="timeline-img"
                                      controls
                                      autoPlay={false}
                                    />
                                  </>
                                )}
                              </div>
                              <div className="testimonySec_card_txt text-break">
                                <p className="text-white mb-0 mt-2">
                                  {comment?.comment}
                                </p>
                              </div>
                            </div>
                            <div className="testimonySec_card_author d-flex align-items-center">
                              {comment?.user?.profileImageUrl?.substring(
                                comment?.user?.profileImageUrl?.lastIndexOf(
                                  "/"
                                ) + 1
                              ) === "userDefault.png" ? (
                                <div className="userDefault">
                                  <ImageElement
                                    className="overflow-hidden rounded-circle"
                                    previewSource={
                                      comment?.user?.profileImageUrl
                                    }
                                  />
                                </div>
                              ) : (
                                <ImageElement
                                  className="overflow-hidden rounded-circle"
                                  previewSource={comment?.user?.profileImageUrl}
                                />
                              )}
                              <div>
                                <h3 className="text-white name">
                                  {comment?.name}
                                </h3>
                                <address className="location mb-0 d-flex align-items-center">
                                  <em className="icon-location" />
                                  {comment?.user?.state?.name},
                                  {comment?.user?.country?.countryCode}
                                </address>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      </>
                    );
                })}
              </Swiper>
              <div className="slider_btn">
                <Button type="button" className="prev">
                  <em className="icon-left-arrow" />
                </Button>
                <Button type="button" className="next">
                  <em className="icon-right-arrow" />
                </Button>
              </div>
            </div>
          )}
        </Container>
      </section>
    </>
  );
}

export default CommentSection03;
